export enum AccessField {
  UserCode = "userCode",
  IntermediaryCode = "intermediaryCode",
  ClientCode = "clientCode",
  Email = "email",
  Roles = "roles",
  Company = "company",
  Zone = "zone",
  Province = "province",
  ProfileIdentification = "identificationProfile",
  HealthProviderCode = "healthProviderCode",
  OfficeCode = "officeCode",
  FiduciaryRnc = "fiduciaryRnc",
  ClientCodeUnit = "clientCodeUnit",
  IntermediaryCodeUnit = "intermediaryCodeUnit",
  PortalStyle = "portalStyle",
}
